/*
  提示框（snackbar）在 App.vue，聽的是「主程式那個 root」的 show-snackbar 事件。

  自訂頁面的短碼（分享按鈕等）是另外 new Vue() 掛上去的獨立實例，
  它們的 this.$root 是自己，對自己發事件沒有人接 —— 提示永遠不會出現，
  例如分享按鈕按了複製，成功失敗都看不到任何回應。
  所以 App.vue 建立時登記主程式的 root，之後一律送到那裡。
*/
let appRoot = null;

/** App.vue 建立時呼叫，登記接收提示的那個 root */
export function setNotifyRoot(root) {
  appRoot = root;
}

export default {
  install(Vue) {
    Vue.prototype.$notify = function ({
      content = "",
      status = null,
      timeout = 3000,
      close = "關閉",
    }) {
      (appRoot || this.$root).$emit("show-snackbar", { content, status, timeout, close });
    };
  },
};
